import { render, staticRenderFns } from "./TotalValue.vue?vue&type=template&id=2bcb0fd2&"
import script from "./TotalValue.vue?vue&type=script&lang=js&"
export * from "./TotalValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports